<!-- Tab.svelte -->
<script lang="ts">
	import { getContext } from 'svelte'
	import type { TabContext } from '$lib/stores/tab-context'
	import { stopPropagation } from '$lib/utils/clickHelpers'
	import { twMerge } from 'tailwind-merge'
	import { override } from '$lib/utils/classnames'

	interface Props {
		index: number
		class?: string
		children?: import('svelte').Snippet<[any]>
		[key: string]: any
	}

	let { class: className = '', children, index, ...rest }: Props = $props()

	const { selected } = getContext<TabContext>('tabs')

	let isSelected = $derived($selected === index)

	function selectTab() {
		selected.set(index)
	}

	let computedButtonClassName = $derived(
		twMerge(
			override(
				'cursor-pointer text-brand-gray-5 hover:text-black dark:hover:text-white dark:text-brand-gray-2 transition-colors touch-manipulation',
				className,
			),
		),
	)
</script>

<button
	{...rest}
	role="tab"
	aria-selected={isSelected}
	tabindex={isSelected ? 0 : -1}
	class={computedButtonClassName}
	onclick={stopPropagation(selectTab)}
>
	{@render children?.({ isSelected })}
</button>
